import { jsx as _jsx } from "react/jsx-runtime";
import { ExpandLess, ExpandMore, Sort } from '@mui/icons-material';
import StyledDataGrid from './Styled';
/**
 * Data Table component.
 * @param props Props.
 * @returns React component.
 */
const DataGrid = (props) => {
    return (_jsx(StyledDataGrid, { disableRowSelectionOnClick: true, disableColumnMenu: true, ...props, slots: {
            columnResizeIcon: () => null,
            columnSortedAscendingIcon: () => _jsx(ExpandLess, { sx: { opacity: 1 } }),
            columnSortedDescendingIcon: () => _jsx(ExpandMore, { sx: { opacity: 1 } }),
            columnUnsortedIcon: () => _jsx(Sort, { sx: { opacity: 1 } }),
            ...props.slots,
        } }));
};
export default DataGrid;
